import { Field, FieldProps, useFormikContext } from 'formik';
import React, { ReactNode } from 'react';

import { OptionProps, RadioGroup, RadioGroupProps } from '@blueprintjs/core';

import { FormGroup } from '../form/Form';

export interface IFormikRadioControlProps {
  name: string;
  label?: string;
  disabled?: boolean;
  options: OptionProps[] | ReactNode;
}
export const FormikRadioControl = (
  props: IFormikRadioControlProps & Omit<RadioGroupProps, 'selectedValue' | 'options' | 'onChange' | 'children'>
) => {
  const { name, label, options, className, ...inputGroupProps } = props;
  const form = useFormikContext<unknown>();

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    form.setFieldValue(name, value);
    form.setFieldTouched(name, true);
  };

  return (
    <FormGroup label={label} labelFor={name} className={className}>
      <Field name={name}>
        {(fieldProps: FieldProps) => (
          <RadioGroup
            {...inputGroupProps}
            options={options as OptionProps[]}
            selectedValue={fieldProps.field.value}
            onChange={handleChange}
          />
        )}
      </Field>
    </FormGroup>
  );
};
